import { requests } from "../../utils";
import {
  RISK_CF_REPORT_ENDPOINT,
  RISK_MTM_REPORT_ENDPOINT,
  RISK_INSTRUMENT_ENDPOINT,
} from "../../common";
import {
  CORRESPONDENT_INSTRUMENT_ENDPOINT,
  RISK_ALERTS_ENDPOINT,
} from "../../common/constants";
import { InstrumentParams, Slice } from "../../types";
import moment from "moment";
import { fileDataFormat } from "../../utils/dateFormat";

export function getReport(url: string, params: Slice, token: string) {
  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: token,
  });
  return requests.get(`${url}/${params.date}/${params.id}`, headers);
}

export function getSlices(params: string, token: string) {
  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: token,
  });
  return requests.get(`${RISK_MTM_REPORT_ENDPOINT}/${params}`, headers);
}

export function getAlerts(token: string) {
  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: token,
  });
  return requests.get(`${RISK_ALERTS_ENDPOINT}`, headers);
}

export function getSummary(token: string) {
  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: token,
  });
  return requests.get(`${RISK_CF_REPORT_ENDPOINT}/latest`, headers);
}

export function getInstrument(params: InstrumentParams, token: string) {
  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: token,
  });
  return requests.get(
    `${RISK_INSTRUMENT_ENDPOINT}/${params.tkrCusip.cusip}/${params.date}/${params.slice}`,
    headers
  );
}

export function getInstrumentSummary(params: InstrumentParams, token: string) {
  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: token,
  });
  return requests.get(
    `${RISK_INSTRUMENT_ENDPOINT}/${params.tkrCusip.cusip}/${moment().format(
      fileDataFormat
    )}/latest`,
    headers
  );
}

export function getCorrespondentByInstrument(
  params: InstrumentParams,
  token: string
) {
  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: token,
  });
  return requests.get(
    `${CORRESPONDENT_INSTRUMENT_ENDPOINT}/${params.tkrCusip.tkr}/${params.date}/${params.slice}`,
    headers
  );
}
